<template>    
    <div class="col-md-12">
        <div class="card card-widget">
            <div class="card-body">
                <facturacionconceptos :id="id" :servicio="servicio" :tipodefactura="tipodefactura"
                    :destinatario="destinatario" :ffac="ffac" />
            </div>
        </div>
    </div>       
    <div class="col-md-12">
        <div class="card card-widget">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-10 text-right">
                        <h4>{{$t('general.Base imponible')}} <strong>{{precios.base_imponible}}&euro;</strong></h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-10">
                        <div class="input-group mb-3" v-if="tipo_factura=='factura'">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{$t('general.descuento antes de impuesto')}}</span>
                            </div>
                            <input type="text" class="form-control"  v-model="conceptodescuento"
                                :placeholder="$t('general.motivo')">
                            <div class="input-group-append">
                                <div class="input-group">
                                    <input type="text" class="form-control" @keyup="calcularTotal('porcentajeantes')" v-model="descuentoantesporcentaje" :placeholder="$t('general.porcentaje')"
                                        style="max-width: 100px">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                        <div class="input-group">
                                            <input type="text" class="form-control" @keyup="calcularTotal('descuentoantes')" v-model="descuentoantes"
                                              :placeholder="$t('general.valor')" style="max-width: 100px">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon1">€</span>
                                            </div>
                                        </div>                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-10 text-right">
                        <h4>{{$t('general.subtotal')}} <strong>{{precios.base_descuento}}&euro;</strong></h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-10 text-right">
                        <h4>I.V.A. <strong>{{precios.iva_normal}}&euro;</strong></h4>
                        <h4 v-if="precios && precios.iva_reducido>0">I.V.A.(Reducido) <strong>{{precios.iva_reducido}}&euro;</strong></h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-10" v-if="tipo_factura=='factura' && sistemaverifactu != 1">
                        <div class="input-group mb-3" v-if="sistemaverifactu != 1">
                            <div class="input-group-prepend">
                                <span class="input-group-text">{{$t('general.descuento después de impuesto')}}</span>
                            </div>
                            <input type="text" class="form-control" @blur="modificarConceptoDespues" v-model="conceptodescuentodespues"
                                :placeholder="$t('general.motivo')">
                            <div class="input-group-append">
                                <div class="input-group">
                                    <input type="text" class="form-control" @keyup="calcularTotal('porcentajedespues')" @blur=" modificarPorcentajeDespues" v-model="porcentajedespues" :placeholder="$t('general.porcentaje')"
                                        style="max-width: 100px">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                        <div class="input-group">
                                            <input type="text" class="form-control" @keyup="calcularTotal('descuentodespues')" @blur=" modificarValorDespues()" v-model="valorDespues"
                                                :placeholder="$t('general.valor')" style="max-width: 100px">
                                            <div class="input-group-append">
                                                <span class="input-group-text" id="basic-addon1">€</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2">
                    </div>
                    <div class="col-md-10 text-right">
                        <h3>Total <strong>{{precios.total}}&euro;</strong></h3>
                    </div>
                </div>
                <div class="row" v-if="precios && precios.iva_reducido>0 && precios.iva_normal>0" >
                    <button class="p-button p-component" type="button"  style="font-weight: bold;cursor:default; width: 100%; background-color: rgb(220, 53, 69); border-color: rgb(220, 53, 69); border-radius: 0.25rem;" data-pc-name="button" data-pc-section="root"><!---->
                        <span class="p-button-label" data-pc-section="label">LA FACTURA TIENE MAS DE UN TIPO DE IVA</span><!----></button>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import facturacionconceptos from './FacturacionNueva/FacturacionNuevaConceptos.vue';
import { PwgsApi } from '../../../../services/PwgsApi';

export default {
    props: ['id', 'servicio', 'direccion','datosfacturacion','tipo_factura','asegurado', 'facturar', 'ffac', 'listatrabajosfacturar', 'destinatario', 'serieseleccionada', 'numeroseleccionado', 'fechaseleccionada', 'vencimiento', 'codigocliente', 'pagoseleccionado', 'cuentabancariaseleccionada', 'descripcionfactura','especialidadseleccionada'],
    components: {
        facturacionconceptos,
    },
    data() {
        return {
            mostrarModulo: false,
            precios: '',         
            conceptodescuento:'',
            conceptodescuentodespues: '',
            valorDespues:'',
            porcentajedespues: '',
            descuentoantes: '',
            descuentoantesporcentaje:'',
            sistemaverifactu:'',
        }
    },
    methods: {
        modificarValorDespues(){
            this.$parent.$parent.$parent.modificarValorDespues(this.valorDespues, this.destinatario[0]);
        },
        modificarPorcentajeDespues(){
            this.$parent.$parent.$parent.modificarPorcentajeDespues(this.porcentajedespues, this.destinatario[0]);
        },
        modificarConceptoDespues(){
            this.$parent.$parent.$parent.modificarConceptoDespues(this.conceptodescuentodespues, this.destinatario[0]);
        },
        cargarprecios() {
            
            this.precios = 0;
            if (this.$props.destinatario[1].totales){
            this.precios = this.$props.destinatario[1].totales;
            }
        },   
        guardarFactura(){ 
            //POST  modulos/pwgsapi/index.php/facturas/:id_servicio/facturar
            var descuimporte = this.precios.dto_antes_iva.split(' ')[0];
            var descu = this.precios.dto_antes_iva.split(' ')[2];
            descu = descu.replace('(', '');
            descu = descu.replace(')', '');

            var descuimporteiva = this.precios.dto_despues_iva.split(' ')[0];
            var descuiva = this.precios.dto_despues_iva.split(' ')[2];
            descuiva = descuiva.replace('(', '');
            descuiva = descuiva.replace(')', '');
            var subidadatos = { 
                tipo: this.tipo_factura,
                id_serie: this.serieseleccionada, 
                numero: this.numeroseleccionado.numero?this.numeroseleccionado.numero:this.numeroseleccionado, 
                fecha_factura: this.fechaseleccionada,
               
                vencimiento_factura: this.vencimiento, 
                codigo_cliente_contabilidad_factura: this.codigocliente, 
                forma_pago: this.pagoseleccionado, 
                cuenta_bancaria: this.cuentabancariaseleccionada, 
                descripcion_factura: this.descripcionfactura, 
                servicio_relacionado: this.especialidadseleccionada, 
                gremio_albaran: this.especialidadseleccionada, 
                concepto_descuento_factura: this.conceptodescuento, 
                descuento:descu, 
                descuento_importe: descuimporte, 
                concepto_descuento_factura_despuesIVA: this.conceptodescuentodespues, 
                descuento_despuesIVA:descuiva,
                descuento_importe_despuesIVA: descuimporteiva 
            };

            this.$parent.$parent.$parent.facturacion(subidadatos);
        },
        async calcularTotal(referencia, nueva) {
            //modulos/pwgsapi/index.php/facturas/:id_servicio/previo-facturacion
            const api = new PwgsApi();
            console.log('datosfac', this.datosfacturacion)
            let auxdest = this.$props.destinatario[0];
            if (referencia == 'porcentajeantes') { this.descuentoantes = ''; }
            if (referencia == 'descuentoantes') { this.descuentoantesporcentaje = ''; }
            if (referencia == 'porcentajedespues') { this.valorDespues = ''; }
            if (referencia == 'descuentodespues') { this.porcentajedespues = ''; }
            if(nueva){
                console.log('entranueva', this.datosfacturacion.descuento.tipo);
                if(this.datosfacturacion.descuento.tipo!='0.000'){
                    var num = parseFloat(this.datosfacturacion.descuento.tipo);                    
                    var numdef = Number.isInteger(num) ? num : num.toFixed(2);
                    this.descuentoantesporcentaje = numdef;
                    console.log('entranueva2', this.descuentoantesporcentaje);
                }else if(this.datosfacturacion.descuento.importe!='0.000'){
                    console.log('entranueva3');
                    var num2 = parseFloat(this.datosfacturacion.descuento.importe);
                    var numdef2 = Number.isInteger(num2) ? num2 : num2.toFixed(2);                    
                    this.descuentoantes = numdef2;
                }
                if(this.datosfacturacion.descuento.concepto!=''){
                    this.conceptodescuento = this.datosfacturacion.descuento.concepto;
                }
            }
            let subidadatos = { descuento: this.descuentoantesporcentaje, descuento_importe: this.descuentoantes, descuento_despuesIVA: this.porcentajedespues, descuento_importe_despuesIVA: this.valorDespues }
            let aux = await api.post('facturas/' + this.$props.id + '/previo-facturacion', subidadatos);
            if (aux[auxdest].totales){
            let auxporcentajeantes = aux[auxdest].totales.dto_antes_iva.split('(')[1];
            let auxporcentajedespues = aux[auxdest].totales.dto_despues_iva.split('(')[1];

            this.descuentoantesporcentaje = auxporcentajeantes.slice(0, -2);
            
            this.descuentoantes = aux[auxdest].totales.dto_antes_iva.split(' ')[0];

            this.porcentajedespues = auxporcentajedespues.slice(0,-2);
            this.valorDespues = aux[auxdest].totales.dto_despues_iva.split(' ')[0];
            this.precios = aux[auxdest].totales;
            }
        }   
        
    },
    mounted(){
        this.cargarprecios();
        this.calcularTotal('', true);
        console.log("mountedsa");
        this.sistemaverifactu = localStorage.getItem('sistema_verifactu');
    },
    watch: {
        id() { 
            console.log("idsa", this.id);
           this.cargarprecios();
        },
        facturar() {         
            this.guardarFactura();
        },
        datosfacturacion() {
            this.descuentoantes = this.$props.datosfacturacion.descuento.tipo;
            this.conceptodescuento = this.$props.datosfacturacion.descuento.concepto;
        },
        
      
    }
}
</script>